import { SearchResultsDto } from "@braoshzmvavz/picnube-common";
import React, { useState } from "react";
import { SearchFilters } from "src/model/SearchFilters";
import {
  setFiles,
  setFolders,
  setIsFirstSearch,
  setLoading,
  setLocations,
} from "src/state/search/searchSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import useApi from "../../services/useApi";
import LastUploadedCard from "./LastUploadedCard";
import ServicesCard from "./ServicesCard";
import OnboardingCard from "./OnboardingCard";
import {
  ActionIcon,
  Card,
  Group,
  Image,
  Menu,
  SimpleGrid,
  Text,
  Grid,
  GridCol,
  Alert,
  Button,
  useMantineTheme,
} from "@mantine/core";
import { HiExclamation, HiPencil } from "react-icons/hi";
import GeneralGallery from "../generalGallery/GeneralGallery";
import Globe from "../albums/sections/Globe";
import GlobeCard from "./GlobeCard";
import AlbumsCard from "./AlbumsCard";
import { useMediaQuery } from "@mantine/hooks";

export default function HomeView(props: {}) {
  const dispatch = useAppDispatch();
  const searchState = useAppSelector((state) => state.search);
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  const profile = useAppSelector((state) => state.profile.profile);
  const space = useAppSelector((state) => state.profile.currentSpace);

  const [showAlert, setShowAlert] = useState(false);

  const { globalSearch, loading } = useApi();

  const onSearchSubmit = (searchFilters: SearchFilters) => {
    console.log("onSearchSubmit", searchFilters);

    dispatch(setLoading(true));

    globalSearch(searchFilters, searchState.filesPage).then(
      (results: SearchResultsDto) => {
        dispatch(setLoading(false));

        dispatch(setIsFirstSearch(false));
        dispatch(setFiles(results.files));
        dispatch(setFolders(results.folders));
        dispatch(setLocations(results.locations));
      }
    );
  };

  const renderMobileHome = () => {
    return <div>Mobile home</div>;
    // TODO: Implement mobile home
  };

  if (isMobile) {
    renderMobileHome();
  }

  return (
    <div className="flex flex-col w-full sm:h-full p-4 xs:p-6 overflow-auto">
      {/*<div className="flex flex-col w-full mb-6">
        <Alert title="Alert title" color="yellow" icon={<HiExclamation />} withCloseButton>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt
          corporis natus veniam quis cupiditate enim architecto mollitia numquam.
        </Alert>
      </div>*/}

      <div className="flex flex-row justify-between">
        <div className="flex flex-col flex-1">
          <Text fw={500} size="xl">
            {space.name}
          </Text>
          <Text c="dimmed" size="sm">
            {space.description}
          </Text>
        </div>
        {/* <Button leftSection={<HiPencil size={16} />} variant="transparent">
          Edit home
        </Button> */}
      </div>

      <div className="w-full sm:h-full h-fit flex flex-col gap-4 mt-6 sm:flex-row overflow-auto">
        {/* <ServicesCard cardClassName="sm:flex-1/4 flex-row sm:flex-col"></ServicesCard> */}
        {/* <AlbumsCard cardClassName="sm:flex-1 flex-row sm:flex-col h-[30rem]"></AlbumsCard> */}
        <LastUploadedCard cardClassName="sm:flex-1 h-full"></LastUploadedCard>
        <GlobeCard cardClassName="sm:flex-1 flex-row sm:flex-col h-[30rem] sm:h-full"></GlobeCard>
      </div>

      {/* <Grid
        className="mt-6"
        type="container"
        grow
        justify="center"
        columns={24}
        breakpoints={{
          xs: "200px",
          sm: "100%",
          md: "100%",
          lg: "100%",
          xl: "100%",
        }}
      >
        <Grid.Col span={{ base: 24, sm: 12, md: 12, lg: 3 }}>
          <OnboardingCard cardClassName=""></OnboardingCard>
        </Grid.Col>
        <Grid.Col span={{ base: 24, sm: 12, md: 12, lg: 3 }}></Grid.Col>
        <Grid.Col span={{ base: 24, sm: 12, md: 12, lg: 3 }}></Grid.Col>
      </Grid> */}
    </div>
  );
}
